<template>
    <form @submit.prevent="getData">
        <div class="row">
            <div class="col-md-12 mt-3 d-flex">
                <label>&nbsp;</label>
                <button v-if="save && !$root.isMobile" @click="saving = true" class="btn mt-2   btn-success" type="submit"
                        style="width: 100%">
                    <i class="fa fa-save"></i> Save entry as new
                </button>
                &nbsp;
                <button @click="$emit('search', true)" class="btn mt-2   btn-primary" type="submit" style="width: 100%">
                    <i class="fa fa-search"></i> Search
                </button>
                &nbsp;
                <button  @click.prevent="clearFilter()" class="btn mt-2   btn-warning" type="reset" style="width: 100%">
                    Clear Filters
                </button>
            </div>

            <div class="col-md-6" v-for="filter in filters.filter(e => e.show_search)">
                <label>{{ filter.label || filter.name }}</label>
                <g-fk-filter :clear="clear" @vmodel="setValue" :form-name="filter.name" :filter="filter"
                             v-if="filter.type === 'fk'"></g-fk-filter>
                <input v-model="form[filter.name]" class="form-control" type="date" v-else-if="filter.type === 'date'">
                <input v-model="form[filter.name]" v-else class="form-control">
            </div>

            <div class="col-md-12 mt-3 d-flex">
                <label>&nbsp;</label>
                <button v-if="save && !$root.isMobile" @click="saving = true" class="btn mt-2   btn-success" type="submit"
                        style="width: 100%">
                    <i class="fa fa-save"></i> Save entry as new
                </button>
                &nbsp;
                <button @click="$emit('search', true)" class="btn mt-2   btn-primary" type="submit" style="width: 100%">
                    <i class="fa fa-search"></i> Search
                </button>
                &nbsp;
                <button  @click.prevent="clearFilter()" class="btn mt-2   btn-warning" type="reset" style="width: 100%">
                     Clear Filters
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import GFkFilter from "./g-fk-filter";

export default {
    name: "g-filters",
    components: {GFkFilter},
    props: {
        save: {
            default: false,
        }
    },
    data() {
        return {
            filters: [],
            form: {},
            saving: false,
            clear: false,
        }
    },
    mounted() {
        this.getFilters();
    },
    methods: {
        getFilters() {
            let app = this;
            axios.post('/apps/filters', {
                model: this.$parent.$props.model
            })
                .then((response) => {
                    app.filters = response.data.data;
                    for (let i = 0; i < app.filters.length; i++) {
                        app.form[app.filters[i].name] = null
                    }
                    app.saving = false;
                })
                .catch((err) => {
                    showMessage('e', 'Error get filters');
                    app.saving = false;
                })
        },
        setValue(value, form) {
            this.form[form] = value
        },
        clearFilter(){
            this.clear = true;
            setTimeout(() =>{
                this.clear = false;
            }, 500)
            for (let i = 0; i < this.filters.length; i++) {
                this.form[this.filters[i].name] = null
            }
            this.$emit('table', [], [])
        },
        getData() {
            let app = this;
            let obj = null;
            axios.post('/apps/filtered', {
                model: this.$parent.$props.model,
                ...this.form,
                is_save: this.saving
            })
                .then((response) => {
                    let cols = app.filters.map((obj) => {
                        return {
                            label: obj.label || obj.name,
                            field: obj.name,
                            globalSearchDisabled: true,
                            sortable: false,
                        }
                    })

                    let rows = response.data.data;
                    if (app.saving) {
                        app.$emit('save', rows);
                    }else{
                        app.$emit('table', cols, rows)
                    }
                })
                .catch((err) => {
                    if (app.saving) {
                        showMessage('e', 'Description field is required');
                    }else {
                        showMessage('e', 'Error get filters');
                    }
                }).finally((e) => {
                if (app.saving) {
                    app.$emit('search', false)
                    app.saving = false;
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
